import { ADD_FLIGHT, BATCH_ADD_FLIGHTS, BATCH_DELETE_FLIGHTS, BATCH_UPDATE_FLIGHT_FIELDS, DELETE_FLIGHT } from "./editCommand";

export const GROUND_TIME_RECALC_FIELDS = new Set(["aircraft_reg", "std", "sta", "departure_airport", "arrival_airport", "track_id"]);
export const DISPLAY_ONLY_TIMING_FIELDS = new Set(["min_ground_time_minutes"]);
export const RECALCULATION_RULE_TRIGGER_FIELDS = new Set(["flight_route_id", "std", "sta", "block_time_minutes", "departure_airport", "arrival_airport"]);
export const LOCAL_CONSTRAINT_RECALC_FIELDS = new Set([
    ...GROUND_TIME_RECALC_FIELDS,
    ...RECALCULATION_RULE_TRIGGER_FIELDS,
    "display_order",
    "change_status",
    "route_snapshot",
    "flight_route_block_time_minutes",
    "min_block_time_minutes",
    "min_ground_time_minutes",
]);
export const ANALYSIS_REFRESH_FIELDS = new Set(LOCAL_CONSTRAINT_RECALC_FIELDS);

function toArray(value) {
    return Array.isArray(value) ? value : [];
}

function getPayloadFields(payload = {}) {
    if (!payload || typeof payload !== "object" || Array.isArray(payload)) {
        return [];
    }
    if (payload.changeSet) {
        return getChangeFields(payload.changeSet?.changes);
    }
    if (Array.isArray(payload.updates)) {
        return payload.updates.flatMap((update) => Object.keys(update?.payload || update?.fields || update?.values || {}));
    }
    return Object.keys(payload).filter((field) => field !== "flightId" && field !== "flight_id");
}

function getChangeFields(changes = []) {
    return toArray(changes).map((change) => change?.field).filter(Boolean);
}

function fieldsHaveImpact(fields, impactFields) {
    return toArray(fields).some((field) => impactFields.has(field));
}

export function fieldsAffectGroundTime(fields = []) {
    return fieldsHaveImpact(fields, GROUND_TIME_RECALC_FIELDS);
}

export function fieldsAffectLocalConstraints(fields = []) {
    return fieldsHaveImpact(fields, LOCAL_CONSTRAINT_RECALC_FIELDS);
}

export function commandAffectsLocalConstraints(command = {}) {
    if ([ADD_FLIGHT, BATCH_ADD_FLIGHTS, DELETE_FLIGHT, BATCH_DELETE_FLIGHTS].includes(command?.type)) {
        return true;
    }
    if (command?.type === BATCH_UPDATE_FLIGHT_FIELDS) {
        return fieldsAffectLocalConstraints(getPayloadFields(command?.payload));
    }
    const fields = getPayloadFields(command?.payload);
    if (!fields.length) {
        return true;
    }
    return fieldsAffectLocalConstraints(fields);
}

export function changeSetAffectsAnalysis(changeSet = {}) {
    return fieldsHaveImpact(getChangeFields(changeSet?.changes), ANALYSIS_REFRESH_FIELDS);
}

export function dirtyFieldsAffectLocalConstraints(dirtyFields) {
    if (!dirtyFields) {
        return false;
    }
    return fieldsAffectLocalConstraints(Array.from(dirtyFields));
}

export function dirtyStateAffectsLocalConstraints(dirtyState = {}) {
    const dirtyFieldsByFlight = dirtyState?.dirtyFieldsByFlight;
    if (!(dirtyFieldsByFlight instanceof Map)) {
        return false;
    }
    return Array.from(dirtyFieldsByFlight.values()).some((dirtyFields) => dirtyFieldsAffectLocalConstraints(dirtyFields));
}

export function flightsHaveConstraintAffectingDirtyFields(flights = []) {
    return toArray(flights).some((flight) => {
        if (!flight?._dirty) {
            return false;
        }
        if (!flight._dirtyFields) {
            return true;
        }
        return dirtyFieldsAffectLocalConstraints(flight._dirtyFields);
    });
}
